import React from 'react';
import classnames from 'classnames';
import renderHTML from 'react-render-html';
import CheckboxInput from './CheckboxInput';
import HiddenInput from './HiddenInput';
import Tooltip from './Tooltip';

const parseLabel = (text) => {
  if (!text) {
    return null;
  }
  return renderHTML(text);
};

const CheckboxHidden = (props) => {
  if (props.drawHidden) {
    return (
      <HiddenInput name={props.name} groupName={props.groupName} value={props.defaultValue} />
    );
  }
  return null;
};
// <HiddenInput
//   name={props.name}
//   groupName={props.groupName}
//   value={props.defaultValue} />
const CheckboxComponent = props => (
  <div className="form-check">
    <CheckboxHidden {...props} />
    <CheckboxInput
      {...props}
      inputClassName={classnames('form-check-input', props.inputClassName)} />
    <label className="form-check-label" htmlFor={props.inputId}>
      {parseLabel(props.label)} <Tooltip id={`tooltip-${props.name}`} title={props.tooltip} />
    </label>
  </div>
);

CheckboxComponent.defaultProps = {
  label: '',
  value: '1',
  defaultValue: '0',
  drawHidden: true,
};

export default CheckboxComponent;
